<template>
  <div class="row g-3">
    <div v-for="card in cards" :key="card.key" class="col-12 col-md-6 col-xl-3">
      <div class="shadow rounded-1 p-3 d-flex align-items-start h-100">
        <span class="widget-icon me-3 flex-shrink-0" style="height: auto">
          <i :class="`fa ${card.icon} text-primary`" />
        </span>
        <div>
          <h3 class="h5 m-0">{{ card.label }}</h3>
          <p class="fs-1 mb-0 mt-2">{{ formatNumber(summary[card.key]) }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    summary: { type: Object, required: true },
  },
  data() {
    return {
      cards: [
        { key: 'jumlahRencanaAksi', label: 'Jumlah Rencana Aksi', icon: 'fa-bar-chart' },
        { key: 'belumPenilaian', label: 'Belum Penilaian', icon: 'fa-hourglass-2' },
        { key: 'sedangPenilaian', label: 'Sedang dalam Penilaian', icon: 'fa-search' },
        { key: 'hasilTersampaikan', label: 'Telah Tersampaikan Hasil Penilaian', icon: 'fa-check-square' },
      ],
    }
  },
  methods: {
    formatNumber(value) {
      return Number(value || 0).toLocaleString('id-ID')
    },
  },
}
</script>
